var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmancircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 43,
    viewBox: "0 0 92 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06771 23.5684C2.21137 23.5684 0 25.7156 0 28.4526C0 31.1896 2.21137 33.3368 5.06771 33.3368C7.92406 33.3368 10.1354 31.1896 10.1354 28.4526C10.1354 25.7156 7.92406 23.5684 5.06771 23.5684ZM5.06771 30.9131C3.73168 30.9131 2.69971 29.8257 2.69971 28.4526C2.69971 27.0795 3.73629 25.992 5.06771 25.992C6.39914 25.992 7.43572 27.0795 7.43572 28.4526C7.43572 29.8257 6.39914 30.9131 5.06771 30.9131Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3411 29.1808L14.2772 23.7114H11.301V33.1942H13.8902V30.1024L13.8671 27.8768L13.8902 27.863L15.1341 31.6967H17.4007L18.6446 27.863L18.6722 27.8768L18.6446 30.1024V33.1942H21.3443V23.7114H18.3912L16.3411 29.1808Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9514 23.7114L22.1137 33.1942H24.901L25.5966 31.2543H28.8446L29.5126 33.1942H32.4472L28.6096 23.7114H25.9514ZM26.3153 29.2638L26.6424 28.3606C26.8635 27.7432 27.0478 27.1949 27.2321 26.5913H27.2597C27.444 27.1811 27.6145 27.7156 27.8356 28.3606L28.1489 29.2638H26.3153Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7125 23.7116V26.7481C39.7125 27.5453 39.7263 28.3609 39.7401 29.158L39.7125 29.1718C39.2426 28.4899 38.7819 27.8494 38.2613 27.1398L35.7459 23.707H33.2166V33.1898H35.8104V30.1533C35.8104 29.3561 35.7965 28.5406 35.7827 27.7434L35.8104 27.7296C36.2803 28.4115 36.741 29.052 37.2616 29.7616L39.777 33.1944H42.3063V23.7116H39.7125Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78641 14.2196L4.31677 12.7451L2.84253 14.2242L4.31217 15.6895L5.78641 14.2196Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2855 11.6947C34.5987 11.6209 34.912 11.5518 35.2161 11.4597C35.5432 11.3583 35.7873 11.151 35.8841 10.8054C35.9901 10.4229 35.9808 10.0405 35.8288 9.66726C35.7136 9.39079 35.5294 9.17423 35.2483 9.05904C34.7462 8.85169 34.0505 9.01757 33.7649 9.65344C33.6497 9.91147 33.599 10.1833 33.5898 10.4598C33.5898 10.575 33.5898 10.6856 33.5898 10.8008C33.3641 10.8515 33.1521 10.8975 32.9356 10.9482V11.9942C32.9586 11.9942 32.9817 11.9896 33.0001 11.985C33.4286 11.8882 33.8616 11.796 34.2901 11.6993L34.2855 11.6947ZM35.1193 10.0036C35.2161 10.0451 35.2806 10.1142 35.2944 10.2248C35.3036 10.3216 35.2714 10.3953 35.1838 10.4321C35.1009 10.469 35.0088 10.4967 34.9166 10.5151C34.6955 10.5658 34.4743 10.6072 34.2486 10.6533C34.2117 10.1372 34.6494 9.81471 35.1193 10.0036Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7493 13.3442C8.12679 18.104 7.74902 19.832 5.56069 19.832H4.63929C3.92981 19.832 2.61681 19.5601 3.42304 17.4497C2.78727 17.247 1.39595 16.9982 0.741754 16.7908C0.33173 17.7446 0.147449 18.7215 0.299481 19.7352C0.502189 21.0853 1.44663 22.5874 5.09077 22.5874C8.02083 22.5874 9.29237 21.7718 10.1308 20.4402C10.8035 19.3712 10.8449 17.1871 9.77611 13.3442H6.7493Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4845 19.5182H24.7443C25.7901 19.5182 26.6331 18.6704 26.6331 17.629V17.1867L27.725 18.5966C28.1765 19.1772 28.8722 19.5182 29.6093 19.5182H36.142C37.1417 19.5136 38.4732 19.4767 39.4683 19.3477C40.4081 19.2279 41.4078 18.9837 42.297 18.6519V15.8136C42.1864 15.8642 40.7859 16.6752 38.5653 16.6752C38.1553 16.6752 36.8561 16.5554 36.8561 15.468C36.8561 15.1454 37.3398 14.4727 38.0539 14.4727C39.0997 14.4727 40.2146 15.0164 40.4956 15.1547C40.8826 14.3068 41.2742 13.4406 41.6704 12.5743C40.6615 11.9753 39.307 11.6113 38.2106 11.6251C34.7645 11.662 34.6493 13.9428 34.6493 14.4911C34.6493 16.0117 35.5523 16.772 35.5523 16.772L30.2404 16.7628C29.8166 16.7628 29.4112 16.5646 29.1486 16.2283C29.1486 16.2283 27.7895 14.4957 27.338 13.9152C26.7898 13.2194 25.9559 12.413 23.9841 12.413C22.0123 12.413 20.9481 14.399 20.9205 16.7628H15.3414C14.8622 16.7628 14.4798 16.3757 14.4798 15.9011V9.45947H11.4761V16.5139C11.4761 18.1727 12.8213 19.5182 14.4798 19.5182H14.4845ZM24.1131 14.998C24.9654 14.998 25.1819 15.385 26.1678 16.5831L26.306 16.7628H22.7034C22.7356 15.984 23.1963 14.998 24.1131 14.998Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9898 30.0239H66.5345V33.4797H69.9898V30.0239Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4136 26.1445L66.5345 30.0243H69.9898V33.4801L73.8689 29.6003L70.4136 26.1445Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8689 8.7915H70.4136V12.2473H73.8689V8.7915Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9898 16.127L73.8689 12.2473H70.4136V8.7915L66.5345 12.6758L69.9898 16.127Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8689 0H70.4136V3.45581H73.8689V0Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9898 7.33554L73.8689 3.45581H70.4136V0L66.5345 3.87973L69.9898 7.33554Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9898 38.8569H66.5345V42.3127H69.9898V38.8569Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4136 34.9727L66.5345 38.857H69.9898V42.3128L73.8689 38.4285L70.4136 34.9727Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8327 0.998655L59.8403 2.72656L61.568 5.71939L64.5603 3.99148L62.8327 0.998655Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1392 9.2848L64.5581 3.98588L61.5682 5.71379L59.8405 2.71875L58.4216 8.02227L63.1392 9.2848Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8965 36.5875L75.9042 38.3154L77.6318 41.3083L80.6241 39.5803L78.8965 36.5875Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3242 33.0098L75.9053 38.3087L78.8952 36.5808L80.6229 39.5758L82.0464 34.2723L77.3242 33.0098Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7744 7.37192L52.0468 10.3647L55.0392 12.0927L56.7668 9.09983L53.7744 7.37192Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1819 14.399L56.763 9.1001L55.0353 12.0905L52.0408 10.3626L53.4643 15.6661L58.1819 14.399Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4792 30.1659L83.7516 33.1587L86.7439 34.8866L88.4716 31.8938L85.4792 30.1659Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3273 27.8494L83.7462 33.153L85.4739 30.1579L88.4684 31.8858L87.0449 26.5869L82.3273 27.8494Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5661 17.4263H49.1108V20.8821H52.5661V17.4263Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4452 21.306L52.5661 17.4263V20.8821H49.1108L52.9899 24.7618L56.4452 21.306Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4171 21.3062H87.9618V24.762H91.4171V21.3062Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.078 20.8821L87.9617 24.7618V21.306H91.417L87.5333 17.4263L84.078 20.8821Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.096 26.7374L50.1037 28.4653L51.8313 31.4582L54.8237 29.7302L53.096 26.7374Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3939 28.158L53.0958 26.7388L54.8235 29.7292L51.8289 31.4571L57.1316 32.8809L58.3939 28.158Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6838 10.671L85.6915 12.3989L87.4191 15.3917L90.4114 13.6638L88.6838 10.671Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1154 13.9708L87.4134 15.39L85.6858 12.3995L88.6803 10.6716L83.3777 9.25244L82.1154 13.9708Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.209 34.5389L56.4814 37.5317L59.4737 39.2596L61.2014 36.2668L58.209 34.5389Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5078 33.1157L58.2097 34.5395L61.1997 36.2628L59.472 39.2579L64.7747 37.8387L63.5078 33.1157Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9954 2.827L79.2678 5.81982L82.2601 7.54773L83.9877 4.55491L80.9954 2.827Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9556 8.97123L82.2582 7.54744L79.2637 5.81953L80.9913 2.8291L75.6932 4.24829L76.9556 8.97123Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.015 15.1002L78.0227 16.8281L79.7503 19.8209L82.7427 18.093L81.015 15.1002Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4494 18.3987L79.7521 19.8179L78.0244 16.8229L81.0144 15.0996L75.7163 13.6758L74.4494 18.3987Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6895 22.3531L57.6971 24.0811L59.4248 27.0739L62.4171 25.346L60.6895 22.3531Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9909 23.7712L60.6882 22.3521L62.4159 25.3425L59.4259 27.0704L64.7286 28.4942L65.9909 23.7712Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8316 25.7435L76.1039 28.7363L79.0963 30.4642L80.8239 27.4714L77.8316 25.7435Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6797 23.4349L76.1033 28.7384L77.8263 25.7434L80.8209 27.4713L79.4019 22.1724L74.6797 23.4349Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.386 11.7689L59.6584 14.7617L62.6507 16.4896L64.3784 13.4968L61.386 11.7689Z",
    fill: "#D50037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7974 18.795L64.3738 13.4961L62.6508 16.4865L59.6562 14.7586L61.0752 20.0621L65.7974 18.795Z",
    fill: "#33B793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.364 18.6501L69.9208 21.0938L72.364 23.5374L74.8073 21.0938L72.364 18.6501Z",
    fill: "#522953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2348 23.5366H72.367L69.9253 21.0945L72.367 18.6523H67.2348V23.5366Z",
    fill: "#33B793"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.417,
    height: 42.313,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmancircle);
export default __webpack_public_path__ + "static/media/omancircle.2d8d310549a9d0638a5e22dd472d47f2.svg";
export { ForwardRef as ReactComponent };